require('../../../../../../resources/js/bootstrap');
import { Toast } from 'bootstrap';

"use strict";

let notification_sound;
let current_settings;
async function setupModule(module_id,actualRoom)
{
    const data = await (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=metadata`)).json();
    current_settings = data.settings //enabled focus message
  //  console.log(data);

    if(current_settings.audio_play == 1 && current_settings.mp3 != "") notification_sound = new Audio(`/room/${actualRoom}/module/${module_id}/public?action=mp3`);
    [].forEach.call(data.user.groups, function(group) {
if(data.group_everyone === group["id"])
{
  //  console.log("everyone");
    Echo.channel(`room.${actualRoom}.module.${module_id}.group.${group["id"]}.update`)
    .listen('.Modules\\PushAnnouncement\\Events\\PushAnnouncement', async (event) => {
  //     console.log("PushAnnouncement", event);
       pushMessageToChatHistory(event.user,event.message)
    });
}
else {
  //  console.log("private group");
    // console.log(`room.${actualRoom}.module.PushAnnouncement.group.${group["id"]}.update`);
    Echo.private(`room.${actualRoom}.module.${module_id}.group.${group["id"]}.update`)
    .listen('.Modules\\PushAnnouncement\\Events\\PushAnnouncement', async (event) => {
  //     console.log("PushAnnouncement", event);
       pushMessageToChatHistory(event.user,event.message)
    });
}

      });

}

async function leaveCall()
{
    //console.log("leaveCall");
//    document.querySelector(".ui-controller").classList.remove("show");
//    call_frame?.leave();
//    disableChat();
    //call_frame?.destroy();
    //Echo.leaveChannel(`private-room.${actualRoom}.module.Question.user.${current_user.id}.settingsChanged`);

}

function pushMessageToChatHistory(user,message)
{
  var currentdate = new Date();
  var currenttime = currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();

  var push_message_template = document.querySelector('#push_message').content.cloneNode(true);
  push_message_template.querySelector("img").src = "https://rm-bpk.de/favicon.ico";
  push_message_template.querySelector(".username").textContent = "Hinweis";
  push_message_template.querySelector(".timestamp").textContent = currenttime;
  push_message_template.querySelector(".message").innerHTML = message;

  var push_history = document.getElementById("push_history");
  push_history.prepend(push_message_template);

  var toastElList = [].slice.call(document.querySelectorAll('.toast'))
        var toastList = toastElList.map(function(toastEl) {
        // Creates an array of toasts (it only initializes them)
          return new Toast(toastEl) // No need for options; use the default options
        });
       toastList.forEach(toast => {
           toast.show();
          toast._element.addEventListener('hidden.bs.toast', function () {
                this.remove();
            });
       });
       try{
           if(current_settings.audio_play == 1 && current_settings.mp3 != "") notification_sound.play();
        }
        catch(e)
        {
            console.log(e);
        }
}

export default async(module_id,actualRoom,settings) =>
{
    console.log('%c 🔔 PushAnnouncementModule Loaded! ', 'background: #222; color: #bada55');
    setupModule(module_id,actualRoom);
    App.loadedModule(module_id,actualRoom);
}
